<template>
    <template v-for="(b, index) in goalTypes"
              :key="`recovery-goal-types-${index}`">
        <recovery-goal-type v-model="goalTypes[index]"
                            :patient-id="patientId"
                            :edit-state="editState"
                            :review-statuses="reviewStatuses"
                            :url-head="urlHead" />
        <hr v-if="index < goalTypes.length - 1">
    </template>
</template>

<script setup>
    import { defineProps, defineEmits, computed, ref } from 'vue';
    import recoveryGoalType from "./RecoveryGoalType.vue";

    const props = defineProps({
        modelValue: {
            type: Array,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        goalPlanId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        reviewStatuses: {
            type: Array,
            default: null
        },
        urlHead: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue']);

    const goalTypes = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });


</script>

<style scoped>
    .goal-type-heading {
        font-size: 120%;
        font-weight: bold;
    }

    .goal-type-sub-heading {
        font-size: 110%;
        font-weight: bold;
    }

</style>